/** GCP's identity-monitor fix generators: how to remediate a finding, as
 * opposed to `./index.ts`'s monitors, which describe what is risky.
 * `./index.ts`'s `accountFixGenerator` merges this with
 * `./aws-fix-generators.ts`'s contribution, selecting by integration at read
 * time (`monitor.fix?.[integration]`). */
import type { Node } from "../../../../graph/types.ts";
import type { AssessmentNodes } from "../../../../types/assessment/data/index.ts";

export const gcloudAccountFixGenerator = (status: "disabled" | "enabled") => ({
  gcloud: {
    description: `${
      status === "disabled" ? "Re-enable" : "Disable"
    } these service accounts by running these commands in Google Cloud Shell.`,
    type: "shell" as const,
    generate: (node: Node<AssessmentNodes, "identity">) =>
      `gcloud iam service-accounts ${
        status === "disabled" ? "enable" : "disable"
      } '${node.key}'`,
  },
});
